import { Color } from '@tmh-website/shared/colors';
import StyledGlobal from '@tmh-website/styles/global';
import StyledTypo from '@tmh-website/styles/typo';
import transparentize from 'polished/lib/color/transparentize';
import styled, { css } from 'styled-components';

export const IconContainer = styled.div`
  padding: 7px;
  background-color: ${props => props.theme.color[Color.Neutral_200_OffWhite]};
  border-radius: ${props => props.theme.borderRadius.small};
  transition: background-color ${props => props.theme.transitionTiming};
  @media (${props => props.theme.breakpoint.sm.up}) {
    padding: 8px;
  }

  svg {
    display: block;
    color: ${props => props.theme.color[Color.Neutral_700]};
  }
`;

export const FakeIconContainer = styled.div`
  ${StyledGlobal.skeletonLoadingCss(Color.Neutral_200_OffWhite)};
  width: 38px;
  height: 38px;
  border-radius: ${props => props.theme.borderRadius.small};
  @media (${props => props.theme.breakpoint.sm.up}) {
    width: 40px;
    height: 40px;
  }
`;

export const ProductImage = styled.img`
  width: 38px;
  height: 38px;
  overflow: hidden;
  background-color: ${props => props.theme.color[Color.Neutral_200_OffWhite]};
  border-radius: ${props => props.theme.borderRadius.small};
  object-fit: contain;
  transition: background-color ${props => props.theme.transitionTiming};
  @media (${props => props.theme.breakpoint.sm.up}) {
    width: 40px;
    height: 40px;
  }
`;

export const InfoContainer = styled.div`
  width: 100%;
  max-width: calc(100% - 56px);
`;

export const Title = styled.p`
  max-width: 100%;
  margin: 0;
  overflow: hidden;
  font-weight: ${props => props.theme.fontWeight.semibold};
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const Type = styled.p`
  margin: 0;
  font-size: 14px;
  opacity: ${({ theme }) => theme.textOpacity};
`;

export const FakeText = styled.div`
  ${StyledGlobal.skeletonLoadingCss(Color.Neutral_200_OffWhite)};
  width: 100%;
  height: 16px;
  margin-bottom: 4px;
  border-radius: ${({ theme }) => (theme.isBorderRadiusDisabled ? 0 : '2px')};

  &:last-child {
    max-width: 130px;
    margin-bottom: 0;
  }
`;

export const NewTabInfo = styled.div`
  ${StyledTypo.uiTextCss};
  position: absolute;
  top: 0;
  right: 16px;
  display: flex;
  gap: 6px;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 10px 0 10px 10px;
  font-size: 14px;
  color: ${props => transparentize(0.4, props.theme.color[Color.Blue_1000_Deep])};
  pointer-events: none;
  background-color: ${props => props.theme.color[Color.Neutral_0_White]};
  opacity: 0;
  transition: background-color ${props => props.theme.transitionTiming},
    opacity ${props => props.theme.transitionTiming};
  @media (${props => props.theme.breakpoint.md.up}) {
    right: ${props => props.theme.wrapperPadding};
  }

  > span {
    @media (${props => props.theme.breakpoint.lg.down}) {
      display: none;
    }
  }
`;

export const Container = styled.a<{ ref?: any; $noHover?: boolean }>`
  position: relative;
  display: flex;
  gap: 10px;
  align-items: center;
  padding: 8px 16px;
  color: ${props => props.theme.color[Color.Blue_1000_Deep]};
  ${props => !props.$noHover && `cursor: pointer;`};
  transition: background-color ${props => props.theme.transitionTiming};
  @media (${props => props.theme.breakpoint.sm.up}) {
    gap: 16px;
    padding: 10px 16px;
  }
  @media (${props => props.theme.breakpoint.md.up}) {
    padding: 10px ${props => props.theme.wrapperPadding};
  }

  ${props =>
    !props.$noHover &&
    css`
      &:hover {
        text-decoration: none;
        background-color: ${props => props.theme.color[Color.Neutral_100]};

        ${NewTabInfo} {
          background-color: ${props => props.theme.color[Color.Neutral_100]};
          opacity: 1;
        }

        ${IconContainer}, ${ProductImage} {
          background-color: ${props => props.theme.color[Color.Neutral_300]};
        }
      }
    `};

  &:first-of-type {
    @media (${props => props.theme.breakpoint.sm.down}) {
      &::after {
        display: none;
        content: none;
      }
    }
  }

  &:last-of-type {
    @media (${props => props.theme.breakpoint.sm.up}) {
      &::after {
        display: none;
        content: none;
      }
    }
  }
`;
